/* eslint-disable max-len */

export default [
  // Выражение с чтением параметра x отсутствуем в исходном коде ФП
  "TypeError: Cannot read property 'x' of undefined",
  // У яндекса нет описания этой ошибки, видимо происходит, когда карта движется, а вкладка неактива
  'Error: map.action.Continuous: ticking while inactive. browser:Chrome behavior:unknown',
  // Ошибка внутри angular-ui в старой форме auth.jade в uib-tab (onDeselect коллбек)
  'TypeError: Не удалось получить свойство "onDeselect" ссылки, значение которой не определено или является NULL',
  // Ошибка во flocktory v2
  "TypeError: Cannot read property '2' of null",
  // Превышен лимит local storage
  'QuotaExceededError: QuotaExceededError',
  // Превышен лимит local storage
  'QuotaExceededError: The quota has been exceeded.',
];
